import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useRegister from '../hooks/useRegister'
import Link from '@material-ui/core/Link'

import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import DownloadAppPlaceHolder from './DownloadAppPlaceHolder'
import logoSpotter from '../images/login-spotter-logo.png'
import Form from '../components/common/Form'
import ListHeader from '../components/common/ListHeader'
import { FieldTypes } from '../utils/constants'

function Copyright() {
  return (
    <div style={{ position: 'absolute', bottom: '0' }}>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit">Spotter</Link> {new Date().getFullYear()}
        {'.'}
      </Typography>
    </div>
  )
}

export default function Register() {
  const location = useLocation()
  let photo = new URLSearchParams(location.search).get('photo')
  photo = photo === 'true'
  const classes = useStyles()
  const email = new URLSearchParams(location.search).get('email')
  const [values, setValues] = useState({ email })
  const [submit, setSubmit] = useState(false)
  const registerRequest = useRegister(
    values.email,
    values.password,
    values.repeatPassword,
    values.image,
    submit
  )
  useEffect(() => {
    if (
      !registerRequest.isLoading &&
      submit &&
      (registerRequest.data || registerRequest.error)
    ) {
      setSubmit(false)
    }
  }, [registerRequest.isLoading, registerRequest.error, submit])

  if (registerRequest.data) {
    return (
      <DownloadAppPlaceHolder title="Registrado correctamente, continua desde nuestras apps" />
    )
  }

  const handleTakePhoto = (dataUri) => {
    setValues({ ...values, image: dataUri })
  }

  return (
    <div className={classes.paper}>
      <div className={classes.wrapper}>
        <img
          src={logoSpotter}
          style={{
            marginBottom: '20px',
            marginRight: '40px',
            marginTop: '20px',
          }}
          width="180px"
          alt="spotter"
        />
        <ListHeader bigTitle="Registrarse" canCreate={false} />
        <Form
          values={values}
          setValues={setValues}
          extraWidth
          fields={[
            {
              type: FieldTypes.TextField,
              label: 'Email',
              hint: 'Ingrese un email',
              key: 'email',
              errorMessage: 'El email es requerido',
              disabled: true,
            },
            {
              type: FieldTypes.TextField,
              label: 'Contraseña',
              hint: 'Ingrese una contraseña',
              key: 'password',
              fieldType: 'password',
              errorMessage: 'La contraseña es requerida',
            },
            {
              type: FieldTypes.TextField,
              label: 'Repetir contraseña',
              hint: 'Repita su contraseña',
              key: 'repeatPassword',
              fieldType: 'password',
              errorMessage: 'Repetir la contraseña es requerido',
              onKeyDown: (e) => e.key === 'Enter' && setSubmit(true),
            },
            ...(photo
              ? [
                  {
                    type: FieldTypes.TakePhoto,
                    image: values.image,
                    removePhoto: () => setValues({ ...values, image: null }),
                    takePhoto: (dataUri) => {
                      handleTakePhoto(dataUri)
                    },
                  },
                ]
              : []),
          ]}
          handleSubmit={() => setSubmit(true)}
        />
      </div>
      <Copyright />
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    position: 'relative',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  wrapper: {
    maxWidth: '768px',
    width: '100%',
    padding: '20px',
  },
}))
